// **********************************************************************************


import Button from "../../../../components/bases/button/button.js";
import EnTravaux from "../../../../components/bases/entravaux/entravaux.js";
// images

import closeparam from "./assets/closeparam.png"
import openparam from ".//assets/openparam.png"

import subtitle128 from "./assets/subtitle128.png"
import player128 from "./assets/player128.png"
import timeline128 from "./assets/timeline128.png"
import application64 from "./assets/application64.png"

import { Tab,Tabs } from "../../../../components/bases/tabcontrol/tabcontrol.js";


import Tooltip from "../../../../components/bases/tooltips/tooltip.js";

import SubtitleTab from "./tabs/subtitletab.js";
import PlayerTab from "./tabs/playertab.js";
import TimeLineTab from "./tabs/timelinetab.js"
import ApplicationTab from "./tabs/applicationtab.js"

import getText from "../../../../utils/language.js"
import { GlobalContext } from "../../../../utils/globalprovider.js";
import "./appsettings.css"
import React from "react";





class AppSettings extends React.Component
{

    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        this.state = {
            open: false,
            selected: "subtitle",
            menu: [
            ],
            stparams: this.props.stparams,
            timelineparams: this.props.timelineparams,

        }

        this.onClickOnMenu = this.onClickOnMenu.bind(this);

        this.sttabRef = React.createRef();
    }

    onClickOnMenu()
    {
        this.setState({open: !this.state.open});
    }

    setNewStParams(params)
    {

       this.setState({stparams: params})
       //if ((this.sttabRef) && (this.sttabRef.current))
       //     this.sttabRef.current.setNewStParams(params)
    }

    closetabs()
    {
        this.setState({open:false});
    }
    render()
    {

        var tipmenu= getText(3,0, this.context.language);

        if (this.state.open)
        {
            var tab1tip = getText(3,1,this.context.language);
            var tab2tip = getText(3,2,this.context.language);
            var tab3tip = getText(3,3,this.context.language);
            var tab4tip = getText(3,4,this.context.language);

            return (
                <div className="divFullParamSetting" >
                    <div className="divParamSettingOpen">
                        {this.props.children}
                    </div>
                    <div className="divParamSettingRightOpen">
                    
                            <div className="divParamSettingOpenMenu">
                                <Tooltip text= {tipmenu} align="left">
                                <Button width="28px" height="28px" image={closeparam} border={false} disable={false} onClick={this.onClickOnMenu}/>
                                </Tooltip>
                            </div>
                        
                        <div className="divParamSettingContent">
                            <Tabs>
                                <Tab title="" image={subtitle128} tooltip={tab1tip}>
                                <SubtitleTab mkey={this.props.refreshKey} key={this.props.refreshKey} title={tab1tip} codatas ={this.props.codatas} defaultsparams = {this.props.defaultsparams} stparams={this.state.stparams} onchange={this.props.onchange} ref = {this.sttabRef}/>
                            
                                </Tab>
                                <Tab title="" image={player128} tooltip={tab2tip}>
                                <PlayerTab title={tab2tip} playerparams={this.props.playerparams} onchange={this.props.onchange}/>
                                </Tab>

                                <Tab title="" image={timeline128} tooltip={tab3tip}>
                                <TimeLineTab title="TimeLine" timelineparams={this.props.timelineparams} onchange={this.props.onchange}/>
                                </Tab>

                                <Tab title="" image={application64} tooltip={tab4tip}>
                                <ApplicationTab title="Applications" applicationsparams={this.props.applicationsparams} onchange={this.props.onchange}/>
                                </Tab>

                            </Tabs>                                
                        
                        </div>
                    </div>
                </div>
            )
        }
        else
        {
            return (
                <div className="divFullParamSetting" >
                    <div className="divParamSettingClose">
                        {this.props.children}
                    </div>

                    <div className="divParamSettingRightClose">

                        <div className="divParamSettingOpenMenu">
                            <Tooltip text= {tipmenu} align="left">
                            <Button width="28px" height="28px" image={openparam} border={false} disable={false} onClick={this.onClickOnMenu}/>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                
            )

        }
    }
};

AppSettings.defaultProps = 
{ 
    defaultsparams : {},
    stparams: {},
    timelineparams: {},
    playerparams: {},
    codatas: {coid: -1},
}


export default AppSettings;

